module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "content-form",
    attrs: {
      "method": "POST"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "field field-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }, {
      name: "validate",
      rawName: "v-validate.initial",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }",
      modifiers: {
        "initial": true
      }
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder.name[_vm.lang],
      "name": 'name'
    },
    domProps: {
      "value": _vm._s(_vm.name)
    },
    on: {
      "focus": _vm.inputOnFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "error-fade"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "field-invalid"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])]), _vm._v(" "), _c('div', {
    staticClass: "field field-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business),
      expression: "business"
    }, {
      name: "validate",
      rawName: "v-validate.initial",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }",
      modifiers: {
        "initial": true
      }
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder.business[_vm.lang],
      "name": 'business'
    },
    domProps: {
      "value": _vm._s(_vm.business)
    },
    on: {
      "focus": _vm.inputOnFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "error-fade"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('business')),
      expression: "errors.has('business')"
    }],
    staticClass: "field-invalid"
  }, [_vm._v(_vm._s(_vm.errors.first('business')))])]), _vm._v(" "), _c('div', {
    staticClass: "field field-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate.initial",
      value: ({
        rules: {
          required: true,
          email: true
        }
      }),
      expression: "{ rules: { required: true, email: true } }",
      modifiers: {
        "initial": true
      }
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder.email[_vm.lang],
      "name": 'email'
    },
    domProps: {
      "value": _vm._s(_vm.email)
    },
    on: {
      "focus": _vm.inputOnFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "error-fade"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "field-invalid"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('div', {
    staticClass: "field field-submit mt2"
  }, [_c('button', {
    staticClass: "btn btn-white"
  }, [_vm._v(_vm._s(_vm.placeholder.submit[_vm.lang]))])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "error-fade"
    }
  }, [(_vm.isSubmitted) ? _c('div', {
    staticClass: "field-result field-submitted mt2"
  }, [_vm._v(_vm._s(_vm.result.success[_vm.lang]))]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "error-fade"
    }
  }, [(_vm.errors.any()) ? _c('div', {
    staticClass: "field-result field-errors mt2"
  }, [_vm._v(_vm._s(_vm.result.error[_vm.lang]))]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a134fa72!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 169
// module chunks = 1